module.exports = __webpack_public_path__ + "assets/images/pages/kfc/icon-kfc-1.png?68ea5a8f";